const FONT_STYLESHEET_URL =
  'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=Fraunces:opsz,wght@9..144,700;9..144,800;9..144,900&display=swap'
const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/3T4icn3QKKaTbxiymCD3xY/3AA660F4-25EA-4592-BCA5-7759937F618C.png'

export function initializePerformanceHead() {
  document.title = 'Meal Prep Club | Comidas saludables para congelar'

  setMeta('theme-color', '#143827')
  setMeta(
    'description',
    'Organiza tus comidas saludables de la semana en solo 2 horas con Meal Prep Club.',
  )

  addResourceHint('preconnect', 'https://fonts.googleapis.com')
  addResourceHint('preconnect', 'https://fonts.gstatic.com', 'anonymous')
  addResourceHint('preconnect', 'https://cdn.shopify.com')
  addResourceHint('preconnect', 'https://cdn.magicpatterns.com')
  addResourceHint('preconnect', 'https://images.unsplash.com')
  addResourceHint('dns-prefetch', 'https://www.paypal.com')
  addResourceHint('dns-prefetch', 'https://js.stripe.com')
  preloadHeroImage()
  loadFontsAsynchronously()
}

function setMeta(name: string, content: string) {
  const selector = `meta[name="${name}"]`
  const meta =
    document.head.querySelector<HTMLMetaElement>(selector) ??
    document.createElement('meta')
  meta.name = name
  meta.content = content

  if (!meta.parentNode) {
    document.head.appendChild(meta)
  }
}

function addResourceHint(rel: string, href: string, crossOrigin?: string) {
  if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) {
    return
  }

  const link = document.createElement('link')
  link.rel = rel
  link.href = href

  if (crossOrigin) {
    link.crossOrigin = crossOrigin
  }

  document.head.appendChild(link)
}

function preloadHeroImage() {
  if (
    document.head.querySelector(`link[rel="preload"][href="${HERO_IMAGE_URL}"]`)
  ) {
    return
  }

  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'image'
  link.href = HERO_IMAGE_URL
  link.setAttribute('fetchpriority', 'high')
  document.head.appendChild(link)
}

function loadFontsAsynchronously() {
  if (document.head.querySelector(`link[href="${FONT_STYLESHEET_URL}"]`)) {
    return
  }

  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'style'
  link.href = FONT_STYLESHEET_URL
  link.crossOrigin = 'anonymous'
  link.onload = () => {
    link.rel = 'stylesheet'
  }
  document.head.appendChild(link)
}
